import { MediaInput } from 'generated/graphql';
import { upload } from '@client/components/ajax';
import { pickObject } from '@client/new/helpers/general';

const MEDIA_INPUT_KEYS = [
  'audio',
  'cdn01',
  'height',
  'image',
  'mimeType',
  'source',
  'video',
  'width',
] as const;

export const uploadMediaInputs = async (
  files: File[],
  videoUuids: string[],
  creatorId: number,
): Promise<MediaInput[]> => {
  const uploaded = await Promise.all(
    files.map((file) => upload(file, creatorId, {})),
  );
  const fileInputs = uploaded.map((item) => pickObject(item, MEDIA_INPUT_KEYS));
  // Video is already in the creator's Mux library; creator-api resolves its
  // real encoding state from the uuid and fills the playback media.
  const videoInputs: MediaInput[] = videoUuids.map((uuid) => ({ uuid }));
  return [...fileInputs, ...videoInputs];
};
